/**
 * @constant Minimum 32-bit signed integer value (-2^31).
 */

    module.exports = -2147483648;

